// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insight_wrapper {
  border-radius: 5px;
  overflow: hidden;
  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;
}
.icon_and_table {
  display: flex;
  gap: 10px;
  padding: 12px;
}

.card_heading {
  background: rgb(214, 229, 249);
  width: 100%;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 5px 5px 0 0;
}

.insight_table_wrapper {
  border-radius: 11px;
  overflow: hidden;
  border: 1px solid rgba(205, 205, 205, 0.471);
}

.image_section img {
  width: 50px;
  height: 50px;
}
.insight_table_wrapper table {
  border-collapse: collapse;
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
  table-layout: fixed;
  height: 100%;
}

.insight_table th,
.insight_table td {
  text-align: center;
  padding: 19px 8px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(205, 205, 205, 0.471);
}

.insight_table td {
  font-family: monospace;
  background: rgb(255, 255, 255);
}
.insight_table th {
  background-color: #1f77b4;
  font-size: 14px;
  color: #faf8f8 !important;
  border: 1px solid white;
  text-wrap: wrap;
  letter-spacing: 0.8px;
  font-family: sans-serif;
}

/* Applying border-radius to specific cells */
.insight_table thead th:first-child {
  border-top-left-radius: 10px;
}
.insight_table thead th:last-child {
  border-top-right-radius: 10px;
}

.insight_table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
.insight_table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

@media screen and (max-width: 900px) {
  .icon_and_table {
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .insight_table_wrapper {
    width: 100% !important;
  }
}

@media screen and (max-width: 600px) {
  .insight_table th {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TableInsightsComp/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".insight_wrapper {\r\n  border-radius: 5px;\r\n  overflow: hidden;\r\n  box-shadow: rgba(116, 116, 165, 0.2) 0px 7px 29px 0px;\r\n}\r\n.icon_and_table {\r\n  display: flex;\r\n  gap: 10px;\r\n  padding: 12px;\r\n}\r\n\r\n.card_heading {\r\n  background: rgb(214, 229, 249);\r\n  width: 100%;\r\n  padding: 10px 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  border-radius: 5px 5px 0 0;\r\n}\r\n\r\n.insight_table_wrapper {\r\n  border-radius: 11px;\r\n  overflow: hidden;\r\n  border: 1px solid rgba(205, 205, 205, 0.471);\r\n}\r\n\r\n.image_section img {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n.insight_table_wrapper table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  margin-bottom: 0;\r\n  table-layout: fixed;\r\n  height: 100%;\r\n}\r\n\r\n.insight_table th,\r\n.insight_table td {\r\n  text-align: center;\r\n  padding: 19px 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border: 1px solid rgba(205, 205, 205, 0.471);\r\n}\r\n\r\n.insight_table td {\r\n  font-family: monospace;\r\n  background: rgb(255, 255, 255);\r\n}\r\n.insight_table th {\r\n  background-color: #1f77b4;\r\n  font-size: 14px;\r\n  color: #faf8f8 !important;\r\n  border: 1px solid white;\r\n  text-wrap: wrap;\r\n  letter-spacing: 0.8px;\r\n  font-family: sans-serif;\r\n}\r\n\r\n/* Applying border-radius to specific cells */\r\n.insight_table thead th:first-child {\r\n  border-top-left-radius: 10px;\r\n}\r\n.insight_table thead th:last-child {\r\n  border-top-right-radius: 10px;\r\n}\r\n\r\n.insight_table tbody tr:last-child td:first-child {\r\n  border-bottom-left-radius: 10px;\r\n}\r\n.insight_table tbody tr:last-child td:last-child {\r\n  border-bottom-right-radius: 10px;\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n  .icon_and_table {\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n  }\r\n  .insight_table_wrapper {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n  .insight_table th {\r\n    font-size: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
